import React from "react";

const Search = () => (
  <div>Account</div>
);

export default Search;